/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  TermsConditions,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    TermsConditionsFromJSON,
    TermsConditionsToJSON,
} from '../models';

export interface GetCurrentTermsAndConditionsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetTermsAndConditionsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetTermsAndConditionsByIdRequest {
    xApplicationScope: ApplicationScope;
    id: string;
}

export interface UpdateCurrentTermsAndConditionsRequest {
    xApplicationScope: ApplicationScope;
    body: Blob;
}

/**
 * 
 */
export class TermsConditionsControllerApi extends runtime.BaseAPI {

    /**
     * get current terms and conditions
     * get current terms and conditions
     */
    async getCurrentTermsAndConditionsRaw(requestParameters: GetCurrentTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getCurrentTermsAndConditions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/terms-conditions/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get current terms and conditions
     * get current terms and conditions
     */
    async getCurrentTermsAndConditions(requestParameters: GetCurrentTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getCurrentTermsAndConditionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all terms and conditions
     * get all terms and conditions
     */
    async getTermsAndConditionsRaw(requestParameters: GetTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TermsConditions>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTermsAndConditions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/terms-conditions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TermsConditionsFromJSON));
    }

    /**
     * get all terms and conditions
     * get all terms and conditions
     */
    async getTermsAndConditions(requestParameters: GetTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TermsConditions>> {
        const response = await this.getTermsAndConditionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all terms and conditions by id
     * get all terms and conditions by id
     */
    async getTermsAndConditionsByIdRaw(requestParameters: GetTermsAndConditionsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getTermsAndConditionsById.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getTermsAndConditionsById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/terms-conditions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get all terms and conditions by id
     * get all terms and conditions by id
     */
    async getTermsAndConditionsById(requestParameters: GetTermsAndConditionsByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getTermsAndConditionsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update current terms and conditions
     * update current terms and conditions
     */
    async updateCurrentTermsAndConditionsRaw(requestParameters: UpdateCurrentTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateCurrentTermsAndConditions.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateCurrentTermsAndConditions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/pdf';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/terms-conditions/current`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * update current terms and conditions
     * update current terms and conditions
     */
    async updateCurrentTermsAndConditions(requestParameters: UpdateCurrentTermsAndConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCurrentTermsAndConditionsRaw(requestParameters, initOverrides);
    }

}
